import Reveal from "@/components/base/Reveal";
import { aboutImage, experienceImage, teamImage } from "@/mocks/ppcare";

interface BlockProps {
  eyebrow: string;
  title: string;
  highlight: string;
  text: string;
  image: string;
  alt: string;
  reverse?: boolean;
  href: string;
}

function AboutBlock({ eyebrow, title, highlight, text, image, alt, reverse, href }: BlockProps) {
  return (
    <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16">
      <Reveal className={reverse ? "lg:order-2" : ""}>
        <div className="overflow-hidden rounded-lg bg-background-100">
          <img src={image} alt={alt} className="h-64 w-full object-cover object-top md:h-80" />
        </div>
      </Reveal>
      <Reveal className={reverse ? "lg:order-1" : ""} delay={100}>
        <p className="mb-3 font-label text-sm font-medium uppercase tracking-[0.2em] text-accent-600">
          {eyebrow}
        </p>
        <h2 className="text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
          {title} <span className="text-accent-500">{highlight}</span>
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">{text}</p>
        <a
          href={href}
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-500 px-6 py-3 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
        >
          View More
          <i className="ri-arrow-right-line" />
        </a>
      </Reveal>
    </div>
  );
}

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="container flex flex-col gap-16 md:gap-24">
        <AboutBlock
          eyebrow="Who We Are"
          title="About Personal Physician"
          highlight="Care"
          text="Welcome to our premier medical practice in South Florida. Experience unparalleled healthcare with award-winning physicians and a dedicated medical team. Discover quality and convenience in primary care."
          image={aboutImage}
          alt="About Personal Physician Care"
          href="#services"
        />
        <AboutBlock
          eyebrow="Personal Physician Care, P.A."
          title="Personal Physician"
          highlight="Experience"
          text="Your seamless, comfortable, and convenient healthcare journey. Experience warmth, compassion, and cutting-edge facilities for efficient diagnostics. Partner with us for optimal health and peace of mind."
          image={experienceImage}
          alt="Personal Physician Experience"
          reverse
          href="#services"
        />
        <AboutBlock
          eyebrow="Meet Our Team"
          title="Personal Physician"
          highlight="Team"
          text="Delivering Excellence in South Florida. Personalized attention, top-notch medical services, and leading specialists collaborating for your well-being under one roof. Trust PPC for an unmatched healthcare journey that prioritizes your well-being."
          image={teamImage}
          alt="Personal Physician Team"
          href="#providers"
        />
      </div>
    </section>
  );
}